import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';
import { KeywordData } from '../../../types/dashboard';
import PanelContainer from './PanelContainer';
import PanelHeader from './PanelHeader';
import {
  LEARNING_KEYWORD,
  KEYWORD_RANKING_DESCRIPTION,
  KEYWORD_RANKING_STUDENT_DESCRIPTION,
  KEYWORD_AI_DISCLAIMER,
} from '../../../constants';

interface KeywordPanelProps {
  data: KeywordData[];
  isOpen: boolean;
  onClose: () => void;
  studentCount?: number;
}

export default function KeywordPanel({
  data,
  studentCount,
  isOpen,
  onClose,
}: KeywordPanelProps) {
  const cx = classNames.bind(styles);

  return (
    <PanelContainer isOpen={isOpen}>
      <PanelHeader
        cardId="keyword"
        title={LEARNING_KEYWORD}
        isBeta
        onClose={onClose}
      />
      <div className={cx('widget_content', 'keyword')}>
        <ul className={cx('keyword_list')}>
          {data.map((item) => (
            <li key={item.rank} className={cx('keyword_item')}>
              <span className={cx('keyword_item_count')}>{item.rank}</span>
              <span className={cx('keyword_item_title')}>{item.keyword}</span>
            </li>
          ))}
        </ul>
        <div className={cx('keyword_info')}>
          {studentCount !== undefined ? (
            <p className={cx('keyword_desc')}>
              {KEYWORD_RANKING_STUDENT_DESCRIPTION.replace(
                '{N}',
                studentCount.toString()
              )}
            </p>
          ) : (
            <p className={cx('keyword_desc')}>{KEYWORD_RANKING_DESCRIPTION}</p>
          )}
          <p className={cx('subtext')}>※ {KEYWORD_AI_DISCLAIMER}</p>
        </div>
      </div>
    </PanelContainer>
  );
}
